import { render } from "./Devolucion.vue?vue&type=template&id=58ed20cf"
import script from "./Devolucion.vue?vue&type=script&lang=js"
export * from "./Devolucion.vue?vue&type=script&lang=js"

import "./Devolucion.vue?vue&type=style&index=0&id=58ed20cf&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__